import styled from 'styled-components';

import colors from 'styles/colors';

export const ExpertFilterModalContentStyled = styled.div`
  padding: 32px 24px 24px;
  overflow-y: auto;
  height: 100%;
  box-sizing: border-box;

  h3 {
    margin: 0;
    padding: 0;
    font-size: 20px;
    line-height: 1.5;
  }
`;

export const ExpertFilterFormStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
  width: 100%;
`;

export const ExpertFilterSelectWrapperStyled = styled.div`
  width: 100%;
  min-width: 0;
`;

export const ExpertFilterActionsStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

export const ExpertFilterDateWrapperStyled = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  column-gap: 16px;
  width: 100%;
  min-width: 0;
`;

export const InputFieldStyled = styled.input`
  padding: 8px;
  width: 100%;
  border: 1px solid ${colors.gray_scale3};
  border-radius: 4px;
  font-size: 16px;
  line-height: 1.5;
  height: 40px;
  outline: none;

  &:focus {
    border-color: ${colors.brand_2};
  }
`;
